import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import { EP2_quest3Data, EP2_quest3Selected } from '../../../Redux/Slices/selectedOptionSlice';
import './F35.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame35() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let quest1 = useSelector(EP2_quest3Data);

        return (
            <div className="F35_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F35_entryBox">
                    <div className="F35_heading">
                        {
                            language === 'english' ?
                                <p className="F35_headingEnglish">Saira asks the teacher; how could I have better prepared for my first period? What should be the teacher’s response?</p>
                                :
                                <p className="F35_headingUrdu">سائرہ یہی سوال اپنی ٹیچر سے پوچھتی ہے کہ وہ کیسے ماہواری کے لئے پہلے ہی سے تیار ہو سکتی تھی۔ آپ کے خیال میں ٹیچر کا جواب کیا ہونا چاہیے؟</p>
                        }
                    </div>
                    <div className="F35_options">
                        <div onClick={() => { dispatch(EP2_quest3Selected('A'), dispatch(pageUp())) }} className={language === 'english' ? "F35_option" : "F35_optionUrdu"}>
                            {language === 'english' ? `A. ${quest1.headingEnglish.A}` : `${quest1.headingUrdu.A}`}
                        </div>

                        <div onClick={() => { dispatch(EP2_quest3Selected('B'), dispatch(pageUp())) }} className={language === 'english' ? "F35_option" : "F35_optionUrdu"}>
                            {language === 'english' ? `B. ${quest1.headingEnglish.B}` : `${quest1.headingUrdu.B}`}
                        </div>

                    </div>

                    <div className="F35_timeline">
                        <div className='F35_timelineBar'>
                            <div className='F35_timelineFill'></div>
                            <span className='F35_timelineText'>10/19</span>
                        </div>
                    </div>

                    <div className="F35_nextFrames">
                        <div className="F35_nextFrame1"></div>
                        <div className="F35_nextFrame2"></div>
                        <div className="F35_nextFrame3"></div>
                    </div>

                </div>
            </div>
        )
}

export default Frame35;